export const SCORECARDS_ROUTE = "/ai-assist/scorecards/list";

export const SCORECARDS_CHILD_ROUTE = {
  NEW: "/ai-assist/scorecards/new",
  DETAIL: "/ai-assist/scorecards/:scoreCardId",
  EDIT: "/ai-assist/scorecards/:scoreCardId/edit",
};
